export default __webpack_public_path__ + "static/media/eCashImg.6007cd9a.png";